import { render, staticRenderFns } from "./historyCoupons.vue?vue&type=template&id=448df824&scoped=true&"
import script from "./historyCoupons.vue?vue&type=script&lang=js&"
export * from "./historyCoupons.vue?vue&type=script&lang=js&"
import style0 from "./historyCoupons.vue?vue&type=style&index=0&id=448df824&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448df824",
  null
  
)

export default component.exports